import {
  type ViewExtensionContext,
  ViewExtensionProvider,
} from '@blocksuite/affine-ext-loader';
import { SlashMenuConfigExtension } from '@blocksuite/affine-widget-slash-menu';
import { BlockViewExtension, FlavourExtension } from '@blocksuite/std';
import { literal } from 'lit/static-html.js';

import { ColumnsKeymapExtension } from './columns-keymap';
import { columnsSlashMenuConfig } from './configs/slash-menu';
import { effects } from './effects';

export class ColumnsViewExtension extends ViewExtensionProvider {
  override name = 'affine-columns-block';

  override effect() {
    super.effect();
    effects();
  }

  override setup(context: ViewExtensionContext) {
    super.setup(context);
    context.register([
      FlavourExtension('affine:columns'),
      BlockViewExtension('affine:columns', literal`affine-columns`),
      FlavourExtension('affine:column'),
      BlockViewExtension('affine:column', literal`affine-column`),
      ColumnsKeymapExtension,
      SlashMenuConfigExtension('affine:columns', columnsSlashMenuConfig),
    ]);
  }
}
